import type {
  FilterConfig,
  FilterDefinition,
  FilterHandler,
} from '../engine/types';
import {
  FilterId,
  FilterType,
  type MultiFilter,
  type TreeFilter,
} from '../types/filters';
import { customSkillDefinition, customSkillHandler } from './customSkill';

export const multiCustomSkillDefinition: FilterDefinition<
  MultiFilter<TreeFilter>
> = {
  id: FilterId.MULTI_CUSTOM_SKILL,
  name: 'Skill',
  type: FilterType.MULTI,
  wrappedFilterId: FilterId.CUSTOM_SKILL,
  instances: [],
  isVisible: true,
};

export const multiCustomSkillHandler: FilterHandler<MultiFilter<TreeFilter>> = {
  isActive(currentFilterState: MultiFilter<TreeFilter>) {
    return currentFilterState.instances.some((instance) =>
      customSkillHandler.isActive(instance)
    );
  },

  isDefault(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>
  ) {
    return currentFilterState.instances.length === 0;
  },

  getEffectiveFilter(
    currentFilterState: MultiFilter<TreeFilter>,
    _definition: FilterDefinition<MultiFilter<TreeFilter>>,
    config: FilterConfig
  ) {
    const effectiveInstances = currentFilterState.instances.map((instance) =>
      customSkillHandler.getEffectiveFilter(
        instance,
        customSkillDefinition,
        config
      )
    );
    return { ...currentFilterState, instances: effectiveInstances };
  },
};
